import {useQuery} from '@tanstack/react-query'
import {sanityClient} from '@/lib/sanity'
import {AUTHOR_BY_SLUG_QUERY} from '@/lib/sanityQueries'
import type {AuthorWithPosts} from '@/types/author'

export const useAuthor = (slug: string | null | undefined) =>
  useQuery({
    queryKey: ['authors', 'bySlug', slug],
    queryFn: () => {
      if (!slug) return Promise.resolve<AuthorWithPosts | null>(null)
      return sanityClient.fetch<AuthorWithPosts | null>(AUTHOR_BY_SLUG_QUERY, {slug})
    },
    enabled: Boolean(slug),
  })
